import * as React from 'react';
import { toast } from 'react-toastify';
import { useNavigate } from "react-router"
import { EventDeletionComplexProps } from '@pages/eventEditing/components/types.ts'
import useDeleteEvent from '@app/data/editEvent/useDeleteEvent.tsx'
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';


const CustomDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: '20px',
  },
}));


export default function EventDeletionComplex({orgId, eventId}: EventDeletionComplexProps) {
  const [open, setOpen] = React.useState(false);
	const navigate = useNavigate();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

	const { build: deleteEvent, isLoading, error, isSuccess } = useDeleteEvent()
	const deleteEventHandler = () => {
		deleteEvent(orgId, eventId)
		if (error) {
			handleClose()
			toast('Ошибка. Попробуйте позже', { type: 'error' })
		}
		if (isSuccess) {
			handleClose()
			toast('Событие успешно удалено', { type: 'success', autoClose: 2300 })
			setTimeout(() => navigate('/'), 2500)
		}
	}

  return (
    <React.Fragment>
      <Button variant="text" onClick={handleClickOpen}>
        Удалить событие
      </Button>
      <CustomDialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText sx={{color: 'var(--Schemes-On-Surface)'}} id="alert-dialog-description">
            Вы уверены, что хотите удалить событие?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Нет, не удаляйте</Button>
          <Button onClick={deleteEventHandler} autoFocus>
            Да, удаляйте
          </Button>
        </DialogActions>
      </CustomDialog>
    </React.Fragment>
  );
}
